import { useOutletContext } from 'react-router-dom';
import {DashboardContextType} from './LayoutAdmin';
import '../LayoutAdmin/LayoutAdmin.scss'; 
import Dashboard from '../../Admin/Dashboard/Dashboard';
import UserManagement from '../UserManagement/UserManagement';
import UserDetails from '../UserDetails/UserDetails';
import PlanManagements from '../../../components/AdminComponents/PlanManagements/PlanManagements';
import ViewEditPlan from '../../../components/AdminComponents/ViewEditPlan/ViewEditPlan';

function LayoutWrapper() {
  const { isHistoryOpen, toggleHistory } = useOutletContext<DashboardContextType>();
  
  return (
    <div className='admin-content-wrapper'>
      <Dashboard/>

      {/* <UserManagement/> */}

      {/* <UserDetails/> */}

      {/* <PlanManagements/> */}

      {/* <ViewEditPlan/> */}
    </div>
  );
}

export default LayoutWrapper;